import React, {
  ComponentType, memo,
  useCallback,
  useEffect,
  useMemo, useRef,
  useState,
} from 'react';
import {
  Button,
  Chip,
  IconButton,
  InputBase,
  Stack,
  Tooltip,
} from '@mui/material';
import Box from '@mui/material/Box';
import { datagridColors } from '../../assets/datagridStyles';
import {
  DataGridPro,
  GridColDef,
  GridFilterModel,
  GridFooter,
  GridPaginationModel, GridRowId,
  GridSortModel, GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid-pro';
import { Header } from '../AdminPages/Header';
import {GridActionsCellItem, GridRowModes, useGridApiRef} from '@mui/x-data-grid';
import {styled, useTheme} from '@mui/material/styles';
import _, { debounce } from 'lodash';
import AddIcon from '@mui/icons-material/Add';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded';
import api from '../../services/api';
import {
  CheckCircleRounded,
  FilterAltOutlined,
  FilterList, RefreshRounded
} from "@mui/icons-material";
import useMediaQuery from "@mui/material/useMediaQuery";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from '@mui/icons-material/Cancel';
import CircularProgress from "@mui/material/CircularProgress";
import {SlidingPaneAddNew} from "../../components/Page/SlidingPaneAddNew";
import {guideHaveTime} from "../../schema/guideHaveTime";
import {todo} from "../../schema/todo";
import {useStateContext} from "../../hooks/useStateContext";
import Link from "@mui/material/Link";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
const TAB_SCOPES = {
  ALL: 'all',
  MINE: 'mine',
  RESERVATIONS: 'reservations',
} as const;

type TabScope = typeof TAB_SCOPES[keyof typeof TAB_SCOPES];

export const TodoPage: ComponentType = () => {
  const themeQuery = useTheme();

  const isMobile = useMediaQuery(themeQuery.breakpoints.down("lg"));
  const [loading, setLoading] = useState(false);
  const [addNewEntity, setAddNewEntity] = useState(false);
  const [rows, setRows] = useState([]);
  const apiRef = useGridApiRef();
  const [fastSearchValue, setFastSearchValue] = useState<any>('');
  const [rowCount, setRowCount] = useState<any>(0);
  const [dateFilter, setDateFilter] = useState<any>(['', '']);
  const [openHeaderFilters, setOpenHeaderFilters] = useState(false);
  const [openFilters, setOpenFilters] = useState(!isMobile);
  const [activeTab, setActiveTab] = useState<TabScope>(TAB_SCOPES.MINE);
  const [finishingIds, setFinishingIds] = useState<Set<GridRowId>>(new Set());

  const [filterModelStatic, setFilterModelStatic] = useState<GridFilterModel>({items: []});
  const [sortModelStatic, setSortModelStatic] = useState<GridSortModel>([]);
  const [paginationModelStatic, setPaginationModelStatic] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 50,
  });
  const [filters, setFilters] = useState({});
  const autosizeOptions = {
    includeHeaders: true,
    includeOutliers: true,
    outliersFactor: 1.5,
    expand: true,
  };

  const { snoozedTodos, setSnoozedTodos } = useStateContext();

  const fetchLogs = useCallback(() => {
    setLoading(true);

    const searchParams = new URLSearchParams();
    searchParams.set('activeTab', activeTab);

    api.get(`/todos`, searchParams).then((res: any) => {
      setRows(res);
    })
      .then(() => sleep(0))
      .then(() => {
        if (apiRef?.current) {
          apiRef.current.autosizeColumns(autosizeOptions);
        }
      })
      .finally(()=>{
      setLoading(false);
    });
  }, [paginationModelStatic, dateFilter, filters,fastSearchValue,filterModelStatic,activeTab]);

  useEffect(() => {
    fetchLogs();
  }, [paginationModelStatic, dateFilter, filters,fastSearchValue,filterModelStatic, activeTab]);

  const handleSaveClick = useCallback((id: GridRowId) => async () => {
    // rakjuk loadingba a gombot ennél a sornál
    setFinishingIds(prev => {
      const next = new Set(prev);
      next.add(id);
      return next;
    });

    try {
      // ⬇️ Állítsd be a saját végpontodra
      await api.post(`/todos/${id}/confirm`, {});

      // siker: vedd ki a sort a listából és csökkentsd a total-t
      setRows(prev => prev.filter((r: any) => r.id !== id));
      setRowCount((prev: any) => Math.max(0, (prev || 0) - 1));

      // (opcionális) Ha biztosra akarsz menni szerver-oldali lapozásnál:
      fetchLogs();

      // 🔴 Ha done lett, akkor vegyük ki a snoozedTodos listából is
      setSnoozedTodos(prev => prev.filter(todoId => todoId !== id));

    } catch (e) {
      console.error('Finish hívás hiba:', e);
      // (opcionális) mutathatsz snackbart/toastot
    } finally {
      // vedd le a loadingot
      setFinishingIds(prev => {
        const next = new Set(prev);
        next.delete(id);
        return next;
      });
    }
  }, [setRows, setRowCount /*, fetchLogs, api */]);

  const handleDeleteClick = useCallback((id: GridRowId) => async () => {
    // rakjuk loadingba a gombot ennél a sornál
    setFinishingIds(prev => {
      const next = new Set(prev);
      next.add(id);
      return next;
    });

    try {
      // ⬇️ Állítsd be a saját végpontodra
      await api.delete(`/todos/${id}`);

      // siker: vedd ki a sort a listából és csökkentsd a total-t
      setRows(prev => prev.filter((r: any) => r.id !== id));
      setRowCount((prev: any) => Math.max(0, (prev || 0) - 1));

      // (opcionális) Ha biztosra akarsz menni szerver-oldali lapozásnál:
      fetchLogs();

      // 🔴 Ha done lett, akkor vegyük ki a snoozedTodos listából is
      setSnoozedTodos(prev => prev.filter(todoId => todoId !== id));

    } catch (e) {
      console.error('Finish hívás hiba:', e);
      // (opcionális) mutathatsz snackbart/toastot
    } finally {
      // vedd le a loadingot
      setFinishingIds(prev => {
        const next = new Set(prev);
        next.delete(id);
        return next;
      });
    }
  }, [setRows, setRowCount /*, fetchLogs, api */]);


  const columns: GridColDef[] = useMemo(() => {
    const columnArray: GridColDef[] = [
      {
        field: 'row_number',
        type: 'string',
        headerName: '',
        cellClassName: '',
        editable: false,
        maxWidth: 50,
        renderCell: (params: any) => {
          const currentPage = paginationModelStatic.page;
          const pageSize = paginationModelStatic.pageSize;

          const rowIndex =
            currentPage * pageSize +
            params.api.getRowIndexRelativeToVisibleRows(params.id) +
            1;

          const id = params.id;
          return <>{rowIndex}</>;
        },
        renderHeaderFilter: () => {
          return <>
            <IconButton
              size={'small'}
              onClick={() => {
                setOpenHeaderFilters(!openHeaderFilters);
              }}
            >
              <FilterAltOutlined
                sx={{
                  color: '#fff',
                }}
              />
            </IconButton>
          </>;
        },
      },
      {
        field: 'user',
        headerName: 'User',
        editable: false,
        type: 'string',
        renderCell: (params: any) => {
          return <div>{params?.value?.name}</div>;
        },
      },
      {
        field: 'title',
        headerName: 'Title',
        editable: false,
        type: 'string',
      },
      {
        field: 'note',
        headerName: 'Note',
        editable: false,
        type: 'string',
      },
      {
        field: 'due_at',
        headerName: 'Due at',
        editable: false,
        type: 'dateTime',
        valueGetter: (params) => params.value ? new Date(params.value) : null,
      },

      {
        field: 'activity_reservation',
        headerName: 'Connected AR',
        editable: false,
        type: 'string',
        renderCell: (params: any) => {
          return <div>
            <div>{params?.value?.group?.name}</div>
            <Link href={`/activity-reservations/${params?.row?.activity_reservation_id}`}>{params?.value?.activity?.name}</Link>
          </div>;
        },
      },
      {
        field: 'service_reservation',
        headerName: 'Connected SR',
        editable: false,
        type: 'string',
        renderCell: (params: any) => {
          return <div>
            <div>{params?.value?.activity_reservation?.group?.name}</div>
            <Link href={`/service-reservations/${params?.row?.service_reservation_id}`}>{params?.value?.service?.name}</Link>
          </div>;
        },
      },
      {
        field: 'assigned_persons',
        headerName: 'Assigned Persons',
        editable: false,
        type: 'string',
        flex: 1,
        renderCell: (params: any) => {
          const users = params?.value ?? [];

          if (!Array.isArray(users) || users.length === 0) {
            return <span>-</span>;
          }

          return (
            <Box
              sx={{
                display: 'flex',
                gap: 0.5,
                flexWrap: 'wrap',
                maxHeight: 64,
                overflowY: 'auto',
              }}
            >
              {users.map((user: any) => (
                <Chip
                  key={user.id}
                  label={user.name}
                  size="small"
                />
              ))}
            </Box>
          );
        },
      },
      {
        field: 'created_at',
        headerName: 'Created',
        editable: false,
        type: 'dateTime',
        valueGetter: (params) => params.value ? new Date(params.value) : null, // ⬅️ Biztosítja, hogy `Date` objektum legyen
      },


      {
        field: 'actions',
        type: 'actions',
        headerName: '',
        cellClassName: 'actions',
        maxWidth: 50,
        getActions: (props: any) => {
          const isFinishing = finishingIds.has(props.id);

          return [
            <GridActionsCellItem
              icon={
               <Tooltip title={'Confirm'}>
                 {isFinishing
                   ? <CircularProgress size={18} />
                   : <CheckCircleRounded sx={{ fill: '#2e7d32' }} color="success" />}
               </Tooltip>
              }
              label={isFinishing ? 'Finishing…' : 'Finished'}
              onClick={isFinishing ? undefined : handleSaveClick(props.id)}
              disabled={isFinishing}
              showInMenu={false}
            />,
            <GridActionsCellItem
              icon={
                <Tooltip title={'Remove'}>
                  {isFinishing
                    ? <CircularProgress size={18} />
                    : <CancelIcon sx={{ fill: '#d32f2f' }} color="error" />}
                </Tooltip>
              }
              label={isFinishing ? 'Finishing…' : 'Finished'}
              onClick={isFinishing ? undefined : handleDeleteClick(props.id)}
              disabled={isFinishing}
              showInMenu={false}
            />
          ];
        },
        renderHeader: () => <></>,
      },

    ];
    return columnArray;
  }, [
    openHeaderFilters,
    paginationModelStatic,
    finishingIds,
    handleSaveClick
  ]);

  const CustomFooter = () => {
    return (
      <Stack
        direction={'row'}
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 8px',
        }}
      >
        <IconButton
          onClick={() => {
            setAddNewEntity(true);
          }}
        >
          <AddIcon color={'primary'} />
        </IconButton>
        <GridFooter />
      </Stack>
    );
  };
  function CustomSortIconDesc(props: any) {
    return (
      <div
        style={{
          background: '#42948c',
          borderRadius: '40px',
          height: '15px',
          width: '15px',
        }}
      >
        <ArrowDropDownRoundedIcon
          color={'secondary'}
          sx={{
            width: '15px',
            height: '15px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </div>
    );
  }

  function CustomSortIconAsc(props: any) {
    return (
      <div
        style={{
          background: '#42948c',
          borderRadius: '40px',
          height: '15px',
          width: '15px',
        }}
      >
        <ArrowDropUpRoundedIcon
          color={'secondary'}
          sx={{
            width: '15px',
            height: '15px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </div>
    );
  }

  function CustomSortIcon(props: any) {
    return (
      <div
        style={{
          background: '#42948c',
          borderRadius: '40px',
          height: '15px',
          width: '15px',
        }}
      >
        <ArrowDropUpRoundedIcon
          color={'secondary'}
          sx={{
            width: '15px',
            height: '15px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </div>
    );
  }

  const quickFilterRef = useRef<HTMLInputElement | null>(null);

  const CustomToolbar = memo(() => {
    return (
      <GridToolbarContainer
        sx={{
          gap: isMobile ? 0 : 1,
          display: openFilters ? "flex" : "none",
        }}
      >

        <Button
          onClick={()=>{
            setAddNewEntity(true);
          }}
          startIcon={<AddIcon />}
          size={'small'}
        >
          Add new
        </Button>

        <Button
          onClick={()=>{
            fetchLogs();
          }}
          startIcon={<RefreshRounded />}
          size={'small'}
        >
          Refresh
        </Button>

        {!isMobile && (
          <GridToolbarFilterButton/>
        )}

        <Box sx={{flexGrow: 1}}/>

        <GridToolbarQuickFilter
          sx={{width: isMobile ? "120px" : '200px'}}
          debounceMs={400}
          inputRef={(el) => {
            if (el && !quickFilterRef.current) {
              quickFilterRef.current = el; // Megőrzi a ref-et, nem írja felül minden rendernél
            }
          }}
        />

      </GridToolbarContainer>
    );
  });

  const handleFilterModelChange = useCallback((newModel:any) => {
    setFilterModelStatic((prevModel) =>
      JSON.stringify(prevModel) === JSON.stringify(newModel) ? prevModel : newModel
    );
  }, []);

  const handleSortModelChange = useCallback((newModel:any) => {
    setSortModelStatic((prevModel) =>
      JSON.stringify(prevModel) === JSON.stringify(newModel) ? prevModel : newModel
    );
  }, []);

  const handlePaginationModelChange = useCallback((newModel:any) => {
    setPaginationModelStatic((prevModel) =>
      JSON.stringify(prevModel) === JSON.stringify(newModel) ? prevModel : newModel
    );
  }, []);

  const MemoizedCustomToolbar = useMemo(() => CustomToolbar, [
    openFilters
  ]);

  return (
    <>
      <Header
        title={'To Do'}
        hasDateFilter={false}
        onChangeDateFilter={(from, to) => {
          setDateFilter([from, to]);
        }}
        rowCount={rows.length}
        hasPagination={false}
      />

      <Box sx={{
        marginTop: "10px",
        marginLeft: "10px",
        marginRight: "10px",
      }}>
        <Tabs
          sx={{

            background: "#ffffff",
            borderRadius: "10px",
            boxShadow: "0px 0px 10px -5px #00000091",
          }}
          value={activeTab}
          onChange={(_, val: TabScope) => {
            setActiveTab(val);
            // tabváltáskor érdemes a szerveres lapozást nullázni,
            // hogy mindig az elejéről induljon
            setPaginationModelStatic({ page: 0, pageSize: paginationModelStatic.pageSize });
          }}
          variant="scrollable"
          allowScrollButtonsMobile
        >
          <Tab label="My To-dos" value={TAB_SCOPES.MINE} />
          <Tab label="ALL" value={TAB_SCOPES.ALL} />
          <Tab label="RESERVATIONS" value={TAB_SCOPES.RESERVATIONS} />
        </Tabs>
      </Box>

      <Box sx={datagridColors('calc(100vh - 145px)')}>
        <DataGridPro
          unstable_headerFilters={openHeaderFilters}
          apiRef={apiRef}
          sx={{
            pointerEvents: loading ? 'none' : 'auto',
            opacity: loading ? 0.5 : 1,
          }}
          rows={rows}
          getRowClassName={(params: any) => {
            const color =
              params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd';
            return `${color}`;
          }}
          disableColumnMenu={true}
          columns={columns}
          loading={loading}
          disableRowSelectionOnClick
          columnHeaderHeight={38}
          getRowHeight={(row)=> 'auto'}
          hasPagination={true}
          pagination={true}
          paginationMode={'server'}
          filterMode={'server'}
          sortingMode={'server'}
          slots={{
            // @ts-ignore
            columnSortedDescendingIcon: CustomSortIconDesc,
            columnSortedAscendingIcon: CustomSortIconAsc,
            columnUnsortedIcon: CustomSortIcon,
            filterIcon: FilterList,
            headerFilterMenu: null,
            toolbar: MemoizedCustomToolbar,
            footer: CustomFooter,
          }}
          pageSizeOptions={[25, 50, 100]}
          rowCount={rowCount}

          paginationModel={paginationModelStatic}
          filterModel={filterModelStatic}
          sortModel={sortModelStatic}

          onFilterModelChange={handleFilterModelChange}
          onSortModelChange={handleSortModelChange}
          onPaginationModelChange={handlePaginationModelChange}

        />
      </Box>

      {addNewEntity && (
        <SlidingPaneAddNew
          propertiesFromTable={{

          }}
          schema={todo}
          id={'new'}
          hasSlidingPane={false}
          onSubmit={(result) => {
            setAddNewEntity(false);
            fetchLogs();
          }}
          row={{}}
          onClose={(value) => {
            setAddNewEntity(false);
          }}
        />
      )}
    </>
  );
};
function sleep(ms: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
